// extracted by mini-css-extract-plugin
module.exports = {"mw0":"DescriptiveHighlightSection_mw0__CMdls"};